module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesorderreport"
  }, [_c('v-content', [(_vm.filterDrawer == true) ? _c('div', {
    staticStyle: {
      "z-index": "2",
      "opacity": "0.8",
      "background": "#000",
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0px",
      "top": "0px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "rightDrawer",
    attrs: {
      "right": "",
      "absolute": "",
      "light": "",
      "width": "500"
    },
    model: {
      value: (_vm.filterDrawer),
      callback: function($$v) {
        _vm.filterDrawer = $$v
      },
      expression: "filterDrawer"
    }
  }, [(_vm.filterNeedsReloadSo == true) ? _c('v-container', {
    ref: "filterReload"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Filters"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReloadSo == false) ? _c('v-container', {
    ref: "filterShow"
  }, [_c('v-layout', {
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg11": ""
    }
  }, [_c('h2', [_vm._v("FILTER YOUR REPORT")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCloseDrawer.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "regenReport",
    on: {
      "click": function($event) {
        return _vm.fncSearchNewQuotes()
      }
    }
  }, [_vm._v("REGENERATE REPORT")]), _vm._v(" "), _c('v-btn', {
    staticClass: "clearfilters",
    staticStyle: {
      "float": "left !important"
    },
    on: {
      "click": function($event) {
        return _vm.fncClearFilter()
      }
    }
  }, [_vm._v("CLEAR ALL FILTERS")]), _vm._v(" "), _c('v-btn', {
    staticClass: "clearregen",
    staticStyle: {
      "float": "left !important"
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchClearNewQuotes()
      }
    }
  }, [_vm._v("CLEAR & REGENERATE")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.soSearch != '') ? _c('small', [_c('strong', [_vm._v("You currently have search text which could affect your filters.")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("DATE")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "dates",
    attrs: {
      "lg12": ""
    }
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[0]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 0, $$v)
      },
      expression: "reportDate[0]"
    }
  }), _vm._v(" "), (_vm.soLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_vm._v("to")]) : _vm._e(), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "End Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[1]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 1, $$v)
      },
      expression: "reportDate[1]"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("GO")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "or",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_vm._v("OR")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.quoteFilter != 99 && _vm.quoteFilter > 0) ? _c('v-select', {
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "14%",
      "font-size": "12px 1important",
      "margin-top": "-18px"
    },
    attrs: {
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncChangeQuotes('nonchange')
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  }) : _c('v-select', {
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "14%",
      "font-size": "12px 1important",
      "margin-top": "-18px"
    },
    attrs: {
      "label": _vm.fncFilterLabel(),
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncChangeQuotes('nonchange')
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "additional",
    attrs: {
      "lg12": ""
    }
  }, [_c('h3', [_vm._v("OTHER")]), _c('br')]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Vendor")])]), _vm._v(" "), (_vm.fncCheckDone('vendor')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "vendorSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('vendor'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('vendor')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('vendor')
      }
    },
    model: {
      value: (_vm.objVendor),
      callback: function($$v) {
        _vm.objVendor = $$v
      },
      expression: "objVendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Store")])]), _vm._v(" "), (_vm.fncCheckDone('store')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "storeSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('store'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('store')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('store')
      }
    },
    model: {
      value: (_vm.objStore),
      callback: function($$v) {
        _vm.objStore = $$v
      },
      expression: "objStore"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), (_vm.fncCheckDone('status')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "statusSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('status'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('status')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('status')
      }
    },
    model: {
      value: (_vm.objStatus),
      callback: function($$v) {
        _vm.objStatus = $$v
      },
      expression: "objStatus"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.soLoaded == false) ? _c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.soLoaded == true) ? _c('v-flex', {
    staticClass: "poSearchContainer",
    staticStyle: {
      "margin-bottom": "60px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "relative",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    ref: "poSearchField",
    staticClass: "poSearchField",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.soSearch),
      callback: function($$v) {
        _vm.soSearch = $$v
      },
      expression: "soSearch"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "height": "30px",
      "position": "absolute",
      "top": "4px",
      "display": "block",
      "right": "2px"
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchNewQuotes()
      }
    }
  }, [_vm._v("SEARCH")]), _vm._v(" "), (_vm.soSearch != '') ? _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "height": "30px",
      "position": "absolute",
      "top": "4px",
      "display": "block",
      "right": "67px"
    },
    on: {
      "click": function($event) {
        return _vm.fncClearPoSearch()
      }
    }
  }, [_vm._v("CLEAR")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "position": "absolute",
      "height": "30px",
      "top": "4px",
      "display": "block",
      "right": "-105px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncToggleFilters.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Filters")]), _vm._v(" "), (_vm.hasFilters == true && (_vm.objStore != '' && _vm.objStore[0] != 'all') || (_vm.objVendor != '' && _vm.objVendor[0] != 'all') || (_vm.objStatus != '' && _vm.objStatus[0] != 'all') || (_vm.objDepartment != '' && _vm.objDepartment[0] != 'all')) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "position": "absolute",
      "height": "30px",
      "top": "4px",
      "display": "block",
      "right": "-235px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearFilters.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")]), _vm._v("Clear Filters")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.soLoaded == true) ? _c('v-flex', {
    staticClass: "soDatePanel",
    attrs: {
      "xs6": "",
      "id": "so"
    }
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[0]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 0, $$v)
      },
      expression: "reportDate[0]"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "soToRep"
  }, [_c('strong', [_vm._v("to")])]), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "End Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[1]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 1, $$v)
      },
      expression: "reportDate[1]"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.fncClearDateDropdown
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('span', {
    staticClass: "soToRep"
  }, [_c('strong', [_vm._v("OR")])]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown dashDroprep",
    attrs: {
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "label": _vm.fncFilterLabel(),
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncChangeDates()
      }
    },
    model: {
      value: (_vm.soFilter),
      callback: function($$v) {
        _vm.soFilter = $$v
      },
      expression: "soFilter"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.soLoaded == true) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto"
    },
    attrs: {
      "id": "salesReportTable"
    }
  }, [(_vm.totalPages > 1) ? _c('v-pagination', {
    attrs: {
      "length": this.totalPages,
      "page": this.getPage,
      "total-visible": 7
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "paginationRecords",
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowPaginationRecords())
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    style: ({
      'width': _vm.tableWidth + 'px'
    }),
    attrs: {
      "id": "soTable",
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.salesOrderListFilter,
      "disable-initial-sort": "",
      "rows-per-page-items": [25]
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(row) {
        return [_c('tr', _vm._l((_vm.headers), function(header) {
          return _c('th', {
            staticClass: "reportFilters",
            attrs: {
              "valign": "top",
              "width": header.width
            }
          }, [(header.text == 'Vendor') ? _c('span', {
            staticClass: "headerTitle"
          }, [(_vm.objVendor.length > 0 && _vm.objVendor.length > 0 && _vm.objVendor[0] != 'all') ? _c('span', {
            staticClass: "rowHasFilter activator"
          }, [_vm._v("VENDOR"), _c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "font-size": "16px !important",
              "padding-left": "6px",
              "position": "relative",
              "top": "3px"
            }
          }, [_vm._v("filter_alt")])]) : _vm._e(), _vm._v(" "), (_vm.objVendor.length > 0 && header.text == 'Vendor' && _vm.objVendor[0] != 'all') ? _c('v-tooltip', {
            staticStyle: {
              "display": "block",
              "float": "right"
            },
            attrs: {
              "bottom": ""
            }
          }, [_c('span', {
            staticStyle: {
              "display": "block",
              "width": "100%",
              "height": "27px",
              "margin-top": "-13px"
            },
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowVendorFlter())
            }
          })]) : _c('span', [_vm._v("VENDOR")])], 1) : _vm._e(), _vm._v(" "), (header.text == 'Store') ? _c('span', {
            staticClass: "headerTitle"
          }, [(_vm.objStore.length > 0 && _vm.objStore.length > 0 && _vm.objStore[0] != 'all') ? _c('span', {
            staticClass: "rowHasFilter"
          }, [_vm._v("STORE"), _c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "font-size": "16px !important",
              "padding-left": "6px",
              "position": "relative",
              "top": "3px"
            }
          }, [_vm._v("filter_alt")])]) : _vm._e(), _vm._v(" "), (_vm.objStore.length > 0 && header.text == 'Store' && _vm.objStore[0] != 'all') ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            }
          }, [_c('span', {
            staticStyle: {
              "display": "block",
              "width": "100%",
              "height": "27px",
              "margin-top": "-13px"
            },
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowStoreFlter())
            }
          })]) : _c('span', [_vm._v("STORE")])], 1) : _vm._e(), _vm._v(" "), (header.text == 'Status') ? _c('span', {
            staticClass: "headerTitle"
          }, [(_vm.objStatus.length > 0 && _vm.objStatus.length > 0 && _vm.objStatus[0] != 'all') ? _c('span', {
            staticClass: "rowHasFilter"
          }, [_vm._v("STATUS"), _c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "font-size": "16px !important",
              "padding-left": "6px",
              "position": "relative",
              "top": "3px"
            }
          }, [_vm._v("filter_alt")])]) : _vm._e(), _vm._v(" "), (_vm.objStatus.length > 0 && header.text == 'Status' && _vm.objStatus[0] != 'all') ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            }
          }, [_c('span', {
            staticStyle: {
              "display": "block",
              "width": "100%",
              "height": "27px",
              "margin-top": "-13px"
            },
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowStatusFlter())
            }
          })]) : _c('span', [_vm._v("STATUS")])], 1) : _vm._e(), _vm._v(" "), (header.text != 'Vendor' && header.text != 'Store' && header.text != 'Status') ? _c('span', {
            staticClass: "headerTitle"
          }, [_vm._v("\n                  " + _vm._s(_vm.fncUpper(header.text)) + "\n                ")]) : _vm._e()])
        }), 0)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [(_vm.hasOrders == true) ? _c('td', {
          attrs: {
            "width": "100px"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckOrderNo(props.item)))]) : _vm._e(), _vm._v(" "), (_vm.hasOrders == true) ? _c('td', {
          attrs: {
            "width": "200px"
          }
        }, [(_vm.fncCanOrder(props.item)) ? _c('v-btn', {
          staticClass: "elevation-5",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncPlaceOrder(props.item)
            }
          }
        }, [_vm._v("Place Order")]) : _vm._e(), _vm._v(" "), (_vm.fncCanCancelOrder(props.item)) ? _c('i', {
          staticClass: "material-icons tick",
          staticStyle: {
            "color": "green !important",
            "display": "block",
            "float": "left",
            "padding-top": "0px !important"
          },
          attrs: {
            "title": "Ordered"
          }
        }, [_vm._v("check")]) : _vm._e(), (_vm.fncCanCancelOrder(props.item)) ? _c('span', {
          staticStyle: {
            "display": "block",
            "float": "left",
            "color": "green",
            "padding-top": "4px",
            "padding-left": "5px"
          }
        }, [_vm._v("Ordered")]) : _vm._e(), _vm._v(" "), (_vm.fncIsCancelOrder(props.item) && !_vm.fncCanOrder(props.item)) ? _c('i', {
          staticClass: "material-icons tick",
          staticStyle: {
            "color": "red !important",
            "display": "block",
            "float": "left",
            "padding-top": "0px !important"
          },
          attrs: {
            "title": "Order Cancelled"
          }
        }, [_vm._v("close")]) : _vm._e(), (_vm.fncIsCancelOrder(props.item) && !_vm.fncCanOrder(props.item)) ? _c('span', {
          staticStyle: {
            "display": "block",
            "float": "left",
            "color": "red",
            "padding-top": "4px",
            "padding-left": "5px"
          }
        }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.fncIsCancelOrder(props.item) && _vm.fncCanOrder(props.item)) ? _c('i', {
          staticClass: "material-icons tick",
          staticStyle: {
            "color": "red !important",
            "display": "block",
            "float": "left",
            "padding-top": "12px !important"
          },
          attrs: {
            "title": "Order Cancelled"
          }
        }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (!_vm.fncCanOrder(props.item) && !_vm.fncCanCancelOrder(props.item) && !_vm.fncIsCancelOrder(props.item)) ? _c('small', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', {
          attrs: {
            "width": "100px"
          }
        }, [_c('v-menu', {
          attrs: {
            "offset-y": ""
          }
        }, [_c('i', {
          staticClass: "material-icons",
          staticStyle: {
            "color": "#00a99d"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("cloud_download")]), _vm._v(" "), _c('v-list', [(_vm.objAuthorize.privileges.indexOf('VENDOR_REPORT') !== -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewSalesOrder(props.item, false)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("View Order")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.orderNo != '' && props.item.ordered == 1),
            expression: "props.orderNo != '' && props.item.ordered == 1"
          }],
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDownloadCsv(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Order – Excel")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1) ? _c('td', {
          attrs: {
            "width": "175px"
          }
        }, [(_vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1) ? _c('v-btn', {
          staticClass: "elevation-5",
          staticStyle: {
            "margin-right": "10px",
            "background": "#333 !important",
            "color": "#fff !important",
            "float": "left"
          },
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.fncPrintStatus(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons print"
        }, [_vm._v("print")]), _vm._v("Print Jobcard")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 && _vm.fncCheckArticles(props.item)) ? _c('td', {
          attrs: {
            "width": "175px"
          }
        }, [(_vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1) ? _c('v-btn', {
          staticClass: "elevation-5",
          staticStyle: {
            "margin-right": "10px",
            "background": "#333 !important",
            "color": "#fff !important",
            "float": "left"
          },
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.fncPrintTaxInvoice(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons print"
        }, [_vm._v("print")]), _vm._v("Print Invoice")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 && !_vm.fncCheckArticles(props.item)) ? _c('td', {
          attrs: {
            "width": "175px"
          }
        }, [_vm._v("N/A")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.soColumns), function(item, index) {
          return (item.checked) ? _c('td', {
            attrs: {
              "width": _vm.fncGetWidth(item.id)
            }
          }, [_c('div', {
            staticClass: "nowrap"
          }, [(item.id == 'quoteRegion') ? _c('span', [_vm._v(_vm._s(_vm.fncGetRegion(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'soQty') ? _c('span', [_vm._v(_vm._s(_vm.fncGetQty(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'soGlassType') ? _c('span', [_vm._v(_vm._s(_vm.fncGetGlassType(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'soGlassSize') ? _c('span', [_vm._v(_vm._s(_vm.fncGetGlassSize(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'soBranch') ? _c('span', {
            staticStyle: {
              "display": "inline-block",
              "padding-top": "10px"
            }
          }, [_vm._v(_vm._s(_vm.fncGetBranch(props.item)))]) : _vm._e(), _vm._v(" "), (item.id == 'items') ? _c('span', [_vm._v(_vm._s(_vm.fncItemLength(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'customerRating') ? _c('span', [_vm._v(_vm._s(_vm.fncGetCustomerRating(props.item)))]) : _vm._e(), _vm._v(" "), (item.id == 'installationDate') ? _c('span', [_vm._v(_vm._s(_vm.fncGetInstallationDate(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'installationDescription') ? _c('span', [_vm._v(_vm._s(_vm.fncGetInstallationDescription(props.item.items)))]) : _vm._e(), _vm._v(" "), (item.id == 'onsiteTime') ? _c('span', [_vm._v(_vm._s(_vm.fncGetOnsiteTime(props.item)))]) : _vm._e(), _vm._v(" "), (item.id == 'jobComplete') ? _c('span', [_vm._v(_vm._s(_vm.fncGetJobComplete(props.item)))]) : _vm._e(), _vm._v(" "), (item.id == 'cancellationReason') ? _c('span', [_vm._v(_vm._s(_vm.fncGetCancellationReason(props.item)))]) : _vm._e(), _vm._v(" "), (item.id == 'quoteNo' && (props.item.quoteAttachment > 0 || props.item.soAttachment > 0)) ? _c('a', {
            staticClass: "reportAttachment",
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncSoSettings(props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("attach_file")])]) : _vm._e(), _vm._v(" "), (item.id == 'quoteNo' && (props.item.quoteAttachment == 0 && props.item.soAttachment == 0)) ? _c('a', {
            staticClass: "reportAttachment",
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncSoSettings(props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "opacity": "0.2"
            }
          }, [_vm._v("attach_file")])]) : _vm._e(), _vm._v(" "), (item.id == 'quoteNo') ? _c('span', {
            staticStyle: {
              "display": "inline-block",
              "padding-top": "10px"
            }
          }, [_vm._v(_vm._s(props.item[item.id]))]) : _vm._e(), _vm._v(" "), (item.id == 'bwSoNo') ? _c('span', {
            staticStyle: {
              "display": "inline-block",
              "padding-top": "10px"
            }
          }, [_vm._v(_vm._s(props.item.bwSalesOrderNo))]) : _vm._e(), _vm._v(" "), (item.id == 'serviceType') ? _c('span', {
            staticStyle: {
              "display": "inline-block",
              "padding-top": "10px"
            }
          }, [_vm._v(_vm._s(_vm.fncGetServiceType(props.item)))]) : _vm._e(), _vm._v(" "), (item.id != 'responsibleReps' && item.id != 'customerRating' && item.id != 'jobComplete' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo') ? _c('span', [_vm._v(_vm._s(props.item[item.id]))]) : _vm._e(), _vm._v(" "), (item.id == 'soDepartment') ? _c('span', {
            staticStyle: {
              "display": "inline-block"
            }
          }, [_vm._v(_vm._s(props.item.departmentName))]) : _vm._e(), _vm._v(" "), (item.id == 'purchaseOrder') ? _c('span', {
            staticStyle: {
              "display": "inline-block"
            }
          }, [_vm._v(_vm._s(props.item.items[0].purchase_order_number))]) : _vm._e(), _vm._v(" "), (item.id != 'responsibleReps' && item.id != 'purchaseOrder' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo' && item.id != 'quoteNo' && item.id != 'vendorName' && item.id != 'originatorName' && item.id != 'soNo' && item.id != 'bwSalesOrderNo') ? _c('span', [_vm._v(_vm._s(props.item[item.id]))]) : _vm._e(), _vm._v(" "), (item.id != 'responsibleReps' && item.id != 'purchaseOrder' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo' && item.id != 'quoteNo' && item.id != 'vendorName' && item.id != 'originatorName' && item.id != 'soNo' && item.id != 'bwSalesOrderNo') ? _c('span', [_vm._v(_vm._s(props.item[item.id]))]) : _vm._e(), _vm._v(" "), (item.id == 'totalPrice') ? _c('span', {
            staticStyle: {
              "display": "block !important",
              "float": "right !important"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatPrice(props.item, props.item.currency, props.item.totalPrice))
            }
          }) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "nowrap status-container"
          }, [(item.id == 'status' && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1) ? _c('span', [_vm._v(_vm._s(props.item.status))]) : _vm._e(), _vm._v(" "), (item.id == 'status' && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1) ? _c('span', {
            staticStyle: {
              "width": "100%",
              "font-size": "12px",
              "display": "inline-block",
              "float": "left",
              "padding-left": "10px",
              "padding-top": "14px"
            }
          }, [_c('strong', [_vm._v("Current Status:")]), _c('div', {
            staticClass: "currentStatus"
          }, [_vm._v(_vm._s(_vm.fncGetStatus(props.item)))])]) : _vm._e(), _vm._v(" "), (item.id == 'status' && props.item.statusText != false && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            staticStyle: {
              "font-weight": "bold",
              "-webkit-box-shadow": "7px 7px 14px -9px rgba(0,0,0,0.5) !important",
              "-moz-box-shadow": "7px 7px 14px -9px rgba(0,0,0,0.5) !important",
              "box-shadow": "7px 7px 14px -9px rgba(0,0,0,0.5) !important",
              "margin-right": "10px",
              "display": "block",
              "float": "right",
              "clear": "both",
              "font-size": "10px !important"
            },
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncGetNextStatusId(props.item)
              }
            }
          }, [_vm._v(_vm._s(props.item.statusText))]) : _vm._e(), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.filterDrawer == false && item.id == 'status' && props.item.statusText != false && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1),
              expression: "filterDrawer == false && item.id == 'status' && props.item.statusText != false && objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1"
            }],
            staticStyle: {
              "font-size": "12px",
              "font-weight": "bold",
              "padding-left": "10px",
              "display": "block",
              "float": "left",
              "padding-top": "16px"
            }
          }, [_vm._v("Advance To:")]), _vm._v(" "), (item.id == 'status' && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1) ? _c('span', {
            on: {
              "click": function($event) {
                return _vm.fncChangeReportStatus(props.item, props.item.items[0].statusId, false, true)
              }
            }
          }, [_c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            }
          }, [_vm._v("UPDATE STATUS")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'status' && _vm.objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1) ? _c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncViewStatusPopup(props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons",
            attrs: {
              "title": "Status History"
            }
          }, [_vm._v("history")])]) : _vm._e(), _vm._v(" "), (item.id == 'responsibleReps' && _vm.fncCanSetVendorUsers(item, props.item)) ? _c('v-btn', {
            staticStyle: {
              "float": "right"
            },
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetVendorUsers(item, props.item)
              }
            }
          }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (item.id == 'responsibleReps' && _vm.fncCanSetVendorUsers(item, props.item)) ? _c('span', {
            staticStyle: {
              "display": "inline-block",
              "padding-top": "15px"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.fncGetResponsibleReps(props.item, item))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'responsibleReps' && !_vm.fncCanSetVendorUsers(item, props.item)) ? _c('span', [_c('strong', [_vm._v("No Users Available To Select From")])]) : _vm._e()], 1)]) : _vm._e()
        })]
      }
    }], null, false, 4123803619)
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}